import { useMutation } from "@tanstack/react-query"
import { onlinePaymentInititFn, redeemPaymentInitFn } from "../../transactions/payment/payment"

export const useOnlinePaymentInitit = () => {
    return useMutation({
        mutationFn: (payload) => onlinePaymentInititFn(payload),
    })
}

export const useRedeemPaymentInit = () => {
    return useMutation({
        mutationFn: (payload) => redeemPaymentInitFn(payload),
    })
}
